import { render, staticRenderFns } from "./GiftPackageDetails2.vue?vue&type=template&id=21ef2aa1&scoped=true"
import script from "./GiftPackageDetails2.vue?vue&type=script&lang=js"
export * from "./GiftPackageDetails2.vue?vue&type=script&lang=js"
import style0 from "./GiftPackageDetails2.vue?vue&type=style&index=0&id=21ef2aa1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ef2aa1",
  null
  
)

export default component.exports